import React from 'react';
import styles from '../FloatingLabel.module.css';

type FloatingLabelInputProps = {
  placeholder?: string;
  label: string;
  type?: string; // Optional type prop, default is text
  required?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string; // Controlled value
  labelShown?: boolean; // Optional prop to hide the label
  style?: React.CSSProperties; // Optional style prop for custom styles
};

const FloatingLabelInput = ({
  placeholder = '',
  label,
  type,
  required = false,
  disabled = false,
  onChange,
  value, // Controlled by props
  labelShown = true, // Default to true if not provided
  style, // Optional style prop
}: FloatingLabelInputProps) => {
  // Handle the onChange event and pass it up to the parent
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e); // Call the parent-provided onChange if it exists
  };

  return (
    <div className={styles.floatingLabelInput}>
      {/* Only show the label if labelShown is true */}
      {labelShown && (
        <label className={styles.floatingLabel}>
          {label}
          {required && <span className={styles.asterisk}>*</span>}
        </label>
      )}
      <input
        style={style}
        className={styles.input}
        type={type || 'text'}
        placeholder={placeholder}
        value={value} // Display value from parent
        onChange={handleChange} // Pass changes to the parent
        required={required}
        disabled={disabled}
      />
    </div>
  );
};

export default FloatingLabelInput;
